import { useParams } from 'react-router-dom'

import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import { fetchCustomer, getError, getIsDataLoaded, getIsPending } from '@/ducks/customerReducer'

const withCustomerLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = true) =>
    // @ts-ignore
    props => {
      const params = useParams()
      // @ts-ignore
      const customerId = parseInt(params.customer_id)

      return (
        <InitialLoadWrapper
          loadAction={fetchCustomer}
          loadingSelector={getIsPending}
          // @ts-ignore
          loadedSelector={state => getIsDataLoaded(state, customerId)}
          errorSelector={getError}
          forceLoadOnMount={forceLoadOnMount}
          args={customerId}
        >
          <Component {...props} />
        </InitialLoadWrapper>
      )
    }

export default withCustomerLoaded
